module.exports = "<inbrit-user-profile [isProfileForApproval]=\"true\"></inbrit-user-profile>"